<div class="market-pairs">
  <div class="custom-heading py-xl-0 py-lg-0 py-md-0 py-2 px-2 d-flex align-items-xl-center align-items-lg-center align-items-md-center align-items-sm-center align-items-xs-start flex-xl-row flex-lg-row flex-md-row flex-sm-row flex-column justify-content-between">
    <div class="d-flex align-items-xl-center align-items-lg-center align-items-md-center align-items-sm-center align-items-xs-start flex-xl-row flex-lg-row flex-md-row flex-sm-row flex-column">
      
      <div class="d-flex align-items-center">
        <div class="p-1 mx-2 text-color-theme align-self-center">
          {{"portfolio"|translate}}
        </div>
        <!-- <div class="p-1 mx-2" *ngIf="!acc">
          <select style="min-width: 150px;" [(ngModel)]="selectedAccount" class="form-select px-2 primary form-select-sm" (change)="fetchUserPortfolio()">
            <option *ngFor="let acc of accList" value="{{acc.relationCode}}">
              ({{acc.relationCode}}) {{translate.currentLang=='en'?acc.clientNameEn:acc.clientNameAr}}
            </option>
          </select>
        </div> -->
        <div *ngIf="userPortfolio?.Portfolio?.length > 0" class="my-2">
          <input type="text" class="form-control search-text-color" style="height: 30px; width: 250px; border-radius: 2px"
            (keyup)="updateFilter($event)" placeholder="{{ 'search' | translate }}" />
        </div>
      </div>

      <button [disabled]="this.userPortfolio?.Portfolio?.length <= 0" matTooltipPosition="left" class="p-0 m-0"
        matTooltip="{{ 'export-excel' | translate }}" (click)="exportAsExcel()" mat-icon-button color="primary">
        <mat-icon>save_alt</mat-icon>
      </button>

    </div>

    <div class="p-1">
      <button class="btn btn-sm btn-primary" (click)="newOrder()" *ngIf="this.accType !=3">
        <i class="icon ion-md-add px-1"></i>
        {{'new-order'|translate}}
      </button>
    </div>
  </div>
  <div class="tab-content p-0">
    <div class="tab-pane fade show active table-custom pb-0" role="tabpanel" style="max-height: 400px !important;">
      <div class="row no-data m-0 h-100" *ngIf="!isProfileLoading && !portfolioData" style="padding: 6%;">
        <div class="col-md-6  mx-auto">
          <img class="empty-state" src="/assets/img/noData.png" />
          <div class="col-sm-12">
            <h6 class="nodata-msg"> {{'no-portfolio'|translate}} </h6>
          </div>
        </div>
      </div>
      <div *ngIf="isTableVisible">
      <table #TABLE matSort (matSortChange)="sortData($event)" id="sortTable" datatable [dtOptions]="dtOptions"
        class="table table-sm table-dark m-0" *ngIf="this.userPortfolio?.Portfolio?.length > 0">
        <thead style="z-index: 100;" *ngIf="portfolioDataList?.length > 0">
          <tr>
            <th class="fit text-center">{{'actions'|translate}}</th>
            <th mat-sort-header="symbol" class="fit">{{'symbol' | translate }}</th>
            <th mat-sort-header="qty" class="fit">{{'qty'|translate}}</th>
            <th mat-sort-header="custodian" class="fit">{{"custodian"|translate}}</th>
            <th mat-sort-header="cost-price" class="fit">{{"cost-price"|translate}}</th>
            <th mat-sort-header="cost-value" class="fit">{{"cost-value"|translate}}</th>
            <th mat-sort-header="current-price" class="fit">{{"current-price"|translate}}</th>
            <th mat-sort-header="mkt-value" class="fit">{{"mkt-value"|translate}}</th>
            <th *ngIf="isMargin" mat-sort-header="MarginPercentage" class="fit">{{"MarginPercentage"|translate}}</th>
            <th *ngIf="isMargin" mat-sort-header="MarginMarketValue" class="fit">{{"MarginMarketValue"|translate}}</th>
            <!-- <th mat-sort-header="margin-mrkt-value" class="fit">{{"margin-mrkt-value"|translate}}</th> -->
            <th mat-sort-header="gl" class="fit">G/L</th>
            <th mat-sort-header="glpercent" class="fit">G/L %</th>
            <th mat-sort-header="weight" class="fit">{{"weight"|translate}}</th>
          </tr>
        </thead>
        <tbody *ngIf="portfolioDataList?.length > 0">
          <tr *ngFor="let item of portfolioDataList" style="height: 20px;">
            <td class="fit">
              <button  (click)="orderBuy(item,0)" mat-flat-button class="my-class" style="background:#26de81">
                B
              </button>
              <button (click)="orderBuy(item,1)" mat-flat-button class="my-class" style="background: #ff4643">
                S
              </button>
            </td>
            <td class="fit text-center">
              {{
              (translate.currentLang=='en')
              ?item.SymbolNameEn
              :item.SymbolNameAr
              }}
              <i mat-raised-button [matTooltipPosition]="translate.currentLang =='en'? 'before':'after'"
                matTooltip='{{ "hasOrder" | translate }}' matTooltipClass="custom-tooltip tooltip-position"
                *ngIf="item.hasOrders" cclass="fa fa-commenting mx-2" style="color: cadetblue;  font-size: large;"
                [ngStyle]="translate.currentLang == 'ar'? {'transform':'scaleX(-1)' } : {'transform':'scaleX(1)' } ">
              </i>
            </td>
            <td class="fit text-center">
              <div [ngbTooltip]="tooltipContent" placement="left" tooltipClass="my-custom-class"
                triggers="hover:mouseleave">
                {{item.Qty | number: "1.0":"en-US"}}
              </div>
            </td>
            <td class="fit text-center">{{(translate.currentLang=='en')?item.CustodianNameE:item.CustodianNameA}}</td>
            <td class="text-center">{{item.AvgCost }}</td>
            <td class="text-center">{{item.CostValue | number: "1.2-2":"en-US"}}</td>
            <td class="fit text-center">{{item.MarketPrice}}</td>
            <td class="text-center">{{item.MarketValue | number: "1.2-2":"en-US"}}</td>
            <td *ngIf="isMargin" class="text-center">{{ (item.MarginPercentage  | number: "1.2-2":"en-US") + '%'}}</td>
            <td *ngIf="isMargin" class="text-center">{{item.MarginMarketValue | number: "1.2-2":"en-US"}}</td>
            <!-- <td>{{item.MarginMarketValue | number: "1.2-2":"en-US"}}</td> -->
            <td class="text-center" [ngClass]="item.GL > 0 ? 'green': item.GL < 0? 'red':'white'">{{item.GL | number:
              "1.2-2":"en-US"}}
            </td>
            <td class="text-center" [ngClass]="item.GL > 0 ? 'green': item.GL < 0? 'red':'white'">{{item.GLPerc}}%</td>
            <td class="text-center">{{item.Weight}}</td>
            <ng-template #tooltipContent>
              <div class="table-wrapper">
                <table class="table table-sm table-borderless">
                  <thead>
                    <tr>
                      <th></th>
                      <th class="fit text-center">{{'norm'|translate}}</th>
                      <th class="fit text-center">{{'blk'|translate}}</th>
                      <th class="fit text-center">{{'avb'|translate}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="fit text-center">{{'setteled'|translate}}</td>
                      <td> {{item?.SetteledQty | number}}</td>
                      <td> {{item?.BlkSetteledQty | number}}</td>
                      <td> {{item?.AvbSetteledQty | number}}</td>
                    </tr>
                    <tr>
                      <td class="fit text-center">{{'t0'|translate}}</td>
                      <td> {{item?.TPlusZeroQty| number}}</td>
                      <td> {{item?.BlkTPlusZeroQty| number}}</td>
                      <td> {{item?.AvbTPlusZeroQty| number}}</td>
                    </tr>
                    <tr>
                      <td class="fit text-center">{{'t1'|translate}}</td>
                      <td> {{item?.TPlusOneQty| number}}</td>
                      <td> {{item?.BlkTPlusOneQty| number}}</td>
                      <td> {{item?.AvbTPlusOneQty| number}}</td>
                    </tr>
                    <tr>
                      <td class="fit text-center">{{'un-setteled'|translate}}</td>
                      <td> {{item?.NormalQty| number}}</td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ng-template>
          </tr>
        </tbody>

        <tfoot *ngIf="portfolioData?.length > 0">
          <tr class="footer-bg">
            <td class="text-center "></td>
            <td class="text-center "></td>
            <td class="text-center "></td>
            <td *ngIf="!isMargin" class="text-center "></td>
            <td class="text-center "></td>

            <td *ngIf="isMargin" class="text-center "></td>
             <td class="text-center">
              <h6>{{userPortfolio?.TotalCostValue | number: "1.2-2":"en-US"}}</h6>
            </td>
            <td *ngIf="isMargin" class="text-center "></td>
            <td *ngIf="!isMargin" class="text-center "></td>
            <td class="text-center ">
              <h6>{{userPortfolio?.TotalMarketValue | number: "1.2-2":"en-US"}}</h6>
            </td>
            
            <td *ngIf="isMargin" class="text-center "></td>
            <td *ngIf="isMargin">
              <h6>{{totalMarginValue  | number: "1.2-2":"en-US"}}</h6>
            </td>
            <td class="text-center ">
              <h6 [ngClass]="userPortfolio?.TotalGL>0? 'green' : 'red'">{{userPortfolio?.TotalGL | number:
                "1.2-2":"en-US"}}</h6>
            </td>
            <td class="text-center ">
              <h6 [ngClass]="userPortfolio?.TotalGLPer>0? 'green' : 'red'">{{userPortfolio?.TotalGLPer | number:
                "1.2-2":"en-US"}}%</h6>
            </td>
            <td class="text-center "></td>
          </tr>
        </tfoot>
      </table>
    </div>
      <table class="d-flex justify-content-center" *ngIf="isProfileLoading">
        <div class="spinner-border  text-secondary m-5" role="status">
          <span class="sr-only"></span>
        </div>
      </table>
    </div>
  </div>
</div>
<ngx-loading
  [show]="isRequestLoading"
  [config]="{ backdropBorderRadius: '3px' }"
></ngx-loading>